/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CriteriaCategory } from './CriteriaCategory';
import {
    CriteriaCategoryFromJSON,
    CriteriaCategoryFromJSONTyped,
    CriteriaCategoryToJSON,
} from './CriteriaCategory';
import type { CriteriaQualifier } from './CriteriaQualifier';
import {
    CriteriaQualifierFromJSON,
    CriteriaQualifierFromJSONTyped,
    CriteriaQualifierToJSON,
} from './CriteriaQualifier';

/**
 * 
 * @export
 * @interface Criteria
 */
export interface Criteria {
    /**
     * 
     * @type {string}
     * @memberof Criteria
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Criteria
     */
    facility_id: string;
    /**
     * 
     * @type {string}
     * @memberof Criteria
     */
    category_id?: string;
    /**
     * 
     * @type {string}
     * @memberof Criteria
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Criteria
     */
    description?: string;
    /**
     * 
     * @type {CriteriaQualifier}
     * @memberof Criteria
     */
    qualifier: CriteriaQualifier;
    /**
     * 
     * @type {CriteriaCategory}
     * @memberof Criteria
     */
    category?: CriteriaCategory;
    /**
     * 
     * @type {boolean}
     * @memberof Criteria
     */
    is_global: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Criteria
     */
    is_medication_rule?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Criteria
     */
    criteria_rank?: number;
}

/**
 * Check if a given object implements the Criteria interface.
 */
export function instanceOfCriteria(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "facility_id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "qualifier" in value;
    isInstance = isInstance && "is_global" in value;

    return isInstance;
}

export function CriteriaFromJSON(json: any): Criteria {
    return CriteriaFromJSONTyped(json, false);
}

export function CriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): Criteria {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'facility_id': json['facility_id'],
        'category_id': !exists(json, 'category_id') ? undefined : json['category_id'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'qualifier': CriteriaQualifierFromJSON(json['qualifier']),
        'category': !exists(json, 'category') ? undefined : CriteriaCategoryFromJSON(json['category']),
        'is_global': json['is_global'],
        'is_medication_rule': !exists(json, 'is_medication_rule') ? undefined : json['is_medication_rule'],
        'criteria_rank': !exists(json, 'criteria_rank') ? undefined : json['criteria_rank'],
    };
}

export function CriteriaToJSON(value?: Criteria | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'facility_id': value.facility_id,
        'category_id': value.category_id,
        'name': value.name,
        'description': value.description,
        'qualifier': CriteriaQualifierToJSON(value.qualifier),
        'category': CriteriaCategoryToJSON(value.category),
        'is_global': value.is_global,
        'is_medication_rule': value.is_medication_rule,
        'criteria_rank': value.criteria_rank,
    };
}

